<div class="customer-selector-container" [ngClass]="{'has-selection': selectedCustomer}">
  <div class="selector-content">
    <div class="icon-wrapper">
      <mat-icon class="customer-icon">business</mat-icon>
    </div>
    
    <mat-form-field class="customer-select sql-generator-select">
      <mat-select 
        [value]="selectedCustomer?.id" 
        (selectionChange)="onCustomerChange($event.value)"
        placeholder="Select Customer" 
        panelClass="customer-select-panel"
        disableOptionCentering>
        <mat-select-trigger>
          <div class="selected-customer" *ngIf="selectedCustomer">
            <span [matTooltip]="selectedCustomer?.name">
              {{ selectedCustomer?.name }}
            </span>
          </div>
          <div class="no-customer" *ngIf="!selectedCustomer">
            <span>Select Customer</span>
          </div>
        </mat-select-trigger>
        <mat-option disabled class="dropdown-header">
          Customer options
        </mat-option>
        <mat-option *ngFor="let customer of customers" [value]="customer.id" class="customer-option">
          <div class="customer-option-content">
            <div class="customer-info">
              <span class="customer-name">{{customer.name}}</span>
            </div>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  
  <div class="selector-status">
    <div class="selector-loading" *ngIf="loading">
      <mat-spinner diameter="16"></mat-spinner>
    </div>
  </div>
</div>
